//@flow
import { takeLatest, call, put } from 'redux-saga/effects'

import { sagaHandleError, ActionRequiresPropertyError } from '../../helpers'
import { sagaGet } from '../../fetch/index'
import { intoArticleStore } from '../../stores/automation/articleStore'
import { API_AUTOMATION_ARTICLES_URL } from '../../urls.js'
import type { FluxStandardAction } from '../../types'

const FETCH_ARTICLES = 'opinary/FETCH_ARTICLES'

export function fetchAutomationArticles(
  customerId: string
): FluxStandardAction {
  return {
    type: FETCH_ARTICLES,
    payload: {
      customerId,
    },
  }
}

export function* sagafetchAutomationArticles(
  action: FluxStandardAction
): Generator<*, void, *> {
  if (!(action && action.payload && action.payload.customerId)) {
    throw new ActionRequiresPropertyError(FETCH_ARTICLES, 'customerId')
  }

  try {
    const response = yield call(
      sagaGet,
      `${API_AUTOMATION_ARTICLES_URL}?customer=${action.payload.customerId}`
    )
    const json = yield call([response, response.json])

    // TODO: add error handling
    const articles = json && json.results ? json.results : []
    yield put(intoArticleStore(articles))
  } catch (error) {
    yield call(sagaHandleError, error)
  }
}

export function* sagaRepeatedlyfetchAutomationArticles(): Generator<
  *,
  void,
  *
> {
  yield takeLatest(FETCH_ARTICLES, sagafetchAutomationArticles)
}



// WEBPACK FOOTER //
// ./src/sagas/automation/fetchAutomationArticles.js